import { ErrorMessage } from 'formik'
import type { HTMLAttributes, JSX, PropsWithChildren, ReactElement } from 'react'
import cc from 'classcat'

import InfoGroup from './InfoGroup'

type Props = {
  name: string
  label: string
  title?: string
  labelClassName?: string
  labelAfterComponent?: boolean
  meta?: string
  info?: string
  required?: boolean
  tagName?: keyof JSX.IntrinsicElements
} & HTMLAttributes<HTMLDivElement>

export default function FormGroup({
  children,
  meta,
  title,
  info,
  required = false,
  labelClassName,
  labelAfterComponent = false,
  tagName: TagName = 'div',
  label,
  name,
  ...other
}: Readonly<PropsWithChildren<Props>>): ReactElement {
  const labelInfoGroup = (
    <InfoGroup key={label} info={info} meta={meta}>
      <span className={cc(['ep-form-row-label-text', labelClassName])}>
        {label}
        {required ? '*' : ''}
      </span>
    </InfoGroup>
  )

  const component = labelAfterComponent ? (
    <>
      {children}
      {labelInfoGroup}
    </>
  ) : (
    <>
      {labelInfoGroup}
      {children}
    </>
  )

  return (
    <div {...other}>
      <TagName title={title} className="ep-form-row-label">
        {component}
      </TagName>
      <ErrorMessage name={name} />
    </div>
  )
}
